import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { jamaicaLocations, marketplaceBrowseCopy } from '../../config/marketplaceCategories';
import { useTheme } from '../../context/ThemeContext';

import css from './MarketplaceBrowseSidebar.module.css';

/** Quick-access towns shown in the left rail (Craigslist-style). */
const QUICK_AREAS = jamaicaLocations.filter(
  loc => loc.id !== 'all' && loc.id !== 'negril' && loc.id !== 'annotto-bay'
).slice(0, 12);

const MarketplaceBrowseSidebar = ({
  areaId,
  onAreaChange,
  onClearFilters,
  onPostAd,
  hasActiveFilter,
}) => {
  const { isDark } = useTheme();
  const copy = marketplaceBrowseCopy.sidebar;

  return (
    <aside className={classNames(css.sidebar, isDark ? null : css.sidebarLight)} aria-label="Marketplace options">
      <nav className={css.block}>
        <button type="button" className={css.postAd} onClick={onPostAd}>
          {copy.postAd}
        </button>
      </nav>

      <nav className={css.block}>
        <h3 className={css.blockTitle}>{copy.browseTitle}</h3>
        <ul className={css.linkList}>
          <li>
            <button type="button" className={css.sideLink} onClick={onClearFilters}>
              {hasActiveFilter ? copy.clearFilters : copy.allCategories}
            </button>
          </li>
        </ul>
      </nav>

      <nav className={css.block}>
        <h3 className={css.blockTitle}>{copy.goTitle}</h3>
        <ul className={css.linkList}>
          <li><Link to="/" className={css.sideLink}>{copy.home}</Link></li>
          <li><Link to="/runner" className={css.sideLink}>{copy.runnerHub}</Link></li>
          <li><Link to="/merchant" className={css.sideLink}>{copy.merchant}</Link></li>
          <li><Link to="/#noticeboard" className={css.sideLink}>{copy.noticeboard}</Link></li>
        </ul>
      </nav>

      <nav className={css.block}>
        <h3 className={css.blockTitle}>{copy.areasTitle}</h3>
        <ul className={css.linkList}>
          <li>
            <button
              type="button"
              className={classNames(css.sideLink, areaId === 'all' ? css.sideLinkActive : null)}
              onClick={() => onAreaChange('all')}
            >
              {marketplaceBrowseCopy.allAreasLabel}
            </button>
          </li>
          {QUICK_AREAS.map(loc => (
            <li key={loc.id}>
              <button
                type="button"
                className={classNames(css.sideLink, areaId === loc.id ? css.sideLinkActive : null)}
                onClick={() => onAreaChange(loc.id)}
              >
                {loc.label}
              </button>
            </li>
          ))}
        </ul>
        <label className={css.areaSelectWrap} htmlFor="sidebar-area-select">
          <span className={css.areaSelectLabel}>{marketplaceBrowseCopy.locationLabel}</span>
          <select
            id="sidebar-area-select"
            className={css.areaSelect}
            value={areaId}
            onChange={e => onAreaChange(e.target.value)}
          >
            {jamaicaLocations.map(loc => (
              <option key={loc.id} value={loc.id}>
                {loc.label}
              </option>
            ))}
          </select>
        </label>
      </nav>

      <div className={css.block}>
        <h3 className={css.blockTitle}>{copy.legendTitle}</h3>
        <p className={css.legendRow}>
          <span className={classNames(css.kindDot, css.kindDotOnSystem)} aria-hidden="true" />
          {copy.legendOnSystem}
        </p>
        <p className={css.legendRow}>
          <span className={classNames(css.kindDot, css.kindDotOffSystem)} aria-hidden="true" />
          {copy.legendOffSystem}
        </p>
      </div>

      <div className={css.block}>
        <h3 className={css.blockTitle}>{copy.helpTitle}</h3>
        <ul className={css.helpList}>
          <li>{copy.helpEscrow}</li>
          <li>{copy.helpCommunity}</li>
          <li>{copy.helpSafety}</li>
        </ul>
      </div>
    </aside>
  );
};

export default MarketplaceBrowseSidebar;
